// extracted by mini-css-extract-plugin
export var footerNewsletter = "inscriptionNewsletter-module--footer-newsletter--fcebf";
export var footerNewsletterInput = "inscriptionNewsletter-module--footer-newsletter-input--be85e";
export var sectionAlert = "inscriptionNewsletter-module--section-alert--fc087";
export var sectionAlertButton = "inscriptionNewsletter-module--section-alert-button--49def";
export var sectionAlertContent = "inscriptionNewsletter-module--section-alert-content--0fabd";
export var sectionAlertHeader = "inscriptionNewsletter-module--section-alert-header--f460f";
export var sectionAlertModal = "inscriptionNewsletter-module--section-alert-modal--499d4";
export var sectionAlertTitle = "inscriptionNewsletter-module--section-alert-title--fc71c";